import EntryPoint from "@components/entry_point";
import { Body, Link, SectionHeader } from "@sprout/typography";
import useTranslation from "@hooks/use_translation";
import LegalLinks from "@components/legal_links.tsx";
import Container from "@components/ui/container.tsx";
import useProfile from "@/queries/use_profile";
import LoadingSpinner from "@/sprout/loading_spinner";

const Account = () => {
  const { t } = useTranslation("user");
  const { t: tMisc } = useTranslation("misc");
  const { data, isLoading, error } = useProfile();

  const AccountHeader = () => (
    <SectionHeader medium as="h1">
      {t("account")}
    </SectionHeader>
  );

  if (isLoading) {
    return (
      <Container>
        <AccountHeader />
        <div className="flex justify-center items-center h-64">
          <LoadingSpinner size="medium" />
        </div>
      </Container>
    );
  }

  if (error || !data) {
    return (
      <Container>
        <AccountHeader />
        <Body>{t("defaultError")}</Body>
      </Container>
    );
  }

  const {
    email,
    accountCompletion,
    isIdentityVerified,
    identityVerificationPartner,
    hasPendingIdentityVerificationTask,
    pendingIdentityVerificationTaskPartner,
  } = data;

  const firstName = data.firstName || "";
  const lastName = data.lastName || "";
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <Container>
      <EntryPoint
        href="/account/edit"
        sectionHeader={t("account")}
        fullName={fullName}
        isIdentityVerified={isIdentityVerified}
        identityVerificationPartner={identityVerificationPartner}
        email={email}
        completionStatus={accountCompletion}
        showIdentityVerificationActionRequired={hasPendingIdentityVerificationTask}
        pendingIdentityVerificationTaskPartner={pendingIdentityVerificationTaskPartner}
      />

      <div>
        <div className="text-center pb-4">
          <Body>
            <Link href="https://my.greenhouse.com/" external>
              {tMisc("about")}
            </Link>
          </Body>
        </div>

        <LegalLinks />
      </div>
    </Container>
  );
};

export default Account;
